<template>
  <div>
    <search-group title="专票资质查询" @search="findData" @clear="clearValue">

      <Row :gutter="24" class="mb16">
        <Col span="6">
          <Select placeholder="项目名称" v-model="searchData.projectFid">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList"
                    :value="item.value" :key="'keyA'+index">{{item.text}}
            </Option>
          </Select>
        </Col>
        <Col span="10">
          <DatePicker
            v-model="dateList"
            placeholder="申请日期" type="daterange" style="display: block"></DatePicker>
        </Col>
        <Col span="6">
          <Input placeholder="公司名称、纳税人识别号" v-model="searchData.q" @keyup.enter.native="findData"/>
        </Col>
      </Row>
    </search-group>
  </div>
</template>

<script>
  // import SearchGroup from 'components/SearchGroup/index';
  import {getProjects} from "../../../../api/common";
  import {formatDateTime} from "../../../../utils/format";

  export default {
    // name: "SearchList",
    components: {
      // SearchGroup
    },
    data() {
      return {
        projectList: [],
        dateList: [],
        searchData: {
          projectFid: '',
          applyDateStart: '',
          applyDateEnd: '',
          q: '',
          page: 1,
          limit: 10
        }
      }
    },
    methods: {
      format(value){
        if(!value){
          return ''
        }
        return formatDateTime(value,false)
      },
      findData() {
        this.searchData.applyDateStart = this.format(this.dateList[0])
        this.searchData.applyDateEnd = this.format(this.dateList[1])
        this.$emit('findData', this.searchData);
      },
      clearValue() {
        this.dateList = ['', '']
        this.searchData = {
          projectFid: '',
          applyDateStart: '',
          applyDateEnd: '',
          q: '',
          page: 1,
          limit: 10
        }
      }
    },
    created() {
      getProjects().then(res => {
        this.projectList = res.data
        // if (this.projectList && this.projectList.length > 0) {
        //   // this.setProject=true
        //   this.searchData.projectFid = this.projectList[0].value
        //   this.$emit('findData', this.searchData);
        // }
      }).catch(error => {
      })
    }
  }
</script>

<style scoped>
  .width200 {
    width: 200px;
  }

  .width300 {
    width: 300px;
  }

</style>
